import { type EmployerPolicy } from '@factoryfixinc/ats-interfaces';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useEmployerPolicyStore = defineStore('employer-policy', () => {
  const employerPolicies = ref<EmployerPolicy[]>([]);
  const employerPoliciesRecord = ref<Record<string, EmployerPolicy>>();

  return { employerPolicies, employerPoliciesRecord };
});
